import tabletIcon from '@/public/images/buyback/categorry/tablet.svg';
import smartphoneIcon from '@/public/images/buyback/categorry/smartphone.svg';
import laptopIcon from '@/public/images/buyback/categorry/laptop.svg';
import smartwatchIcon from '@/public/images/buyback/categorry/smartwatch.svg';
import appleLogo from '@/public/images/collections/apple_logo.svg';
import samsungLogo from '@/public/images/collections/samsung_logo.svg';
import huaweiLogo from '@/public/images/collections/huawei_logo.svg';
import xiaomiLogo from '@/public/images/collections/xiaomi_logo.svg';
import googleLogo from '@/public/images/collections/google_logo.svg';
import oppoLogo from '@/public/images/collections/oppo_logo.svg';
import vivoLogo from '@/public/images/collections/vivo_logo.svg';
import oneplusLogo from '@/public/images/collections/oneplus_logo.svg';
import lgLogo from '@/public/images/collections/lg_logo.svg';
import sonyLogo from '@/public/images/collections/sony_logo.svg';
import razerLaptopLogo from '@/public/images/collections/razer_laptop_logo.svg';
import fitbitLogo from '@/public/images/collections/fitbit_logo.svg';
import fossilLogo from '@/public/images/collections/fossil_logo.svg';
import mobvoiLogo from '@/public/images/collections/mobvoi_logo.svg';
import htcLogo from '@/public/images/collections/htc_logo.svg';
import nokiaLogo from '@/public/images/collections/nokia_logo.svg';
import motorolaLogo from '@/public/images/collections/motorola_logo.svg';
import blackberryLogo from '@/public/images/collections/blackberry_logo.svg';

export const MAP_BUYBACK_CATEGORY_LOGO: {
  [key: string]: StaticImageData;
} = {
  tablet: tabletIcon,
  smartphone: smartphoneIcon,
  laptop: laptopIcon,
  smartwatch: smartwatchIcon,
};

export const MAP_BUYBACK_BRAND_LOGO: {
  [key: string]: StaticImageData;
} = {
  apple: appleLogo,
  samsung: samsungLogo,
  huawei: huaweiLogo,
  google: googleLogo,
  oppo: oppoLogo,
  vivo: vivoLogo,
  oneplus: oneplusLogo,
  lg: lgLogo,
  razer: razerLaptopLogo,
  xiaomi: xiaomiLogo,
  sony: sonyLogo,
  fitbit: fitbitLogo,
  fossil: fossilLogo,
  mobvoi: mobvoiLogo,
  htc: htcLogo,
  nokia: nokiaLogo,
  motorola: motorolaLogo,
  blackberry: blackberryLogo,
};
